import { Button, Card, Layout, Typography } from "antd";
import styled from "styled-components";

const { Title, Text } = Typography;
export const StyledCard = styled(Card)`
  background: transparent;
  width: 100%;
  height: 300px;
  background: whitesmoke;
  border: 0.5px solid #192238;
  /* border-radius: 10px !important; */
  /* border: 4px solid transparent;  */
  /* border-image: linear-gradient(to right, red, purple); */
  border-image-slice: 1;
  transition: border-color 0.3s ease;
`;

export const StyledTitle = styled(Title)`
  color: white;
`;

export const StyledTryButton = styled(Button)`
  &&.ant-btn-primary {
    /* border-color: rgb(25, 34, 56); */
    /* background:"white"; */
    background-color: white;

    color: black;
    border: none;
    border-radius: 5px;
    margin-left: 10px;
    padding: 0 20px;
    height: 50px;
    font-size: 20px;
    text-align: center;

    &:hover {
      /* background-image: linear-gradient(to right, purple, red); */
      background-color: #192238;
      border-color: #192238;
      color: white;
    }
  }
`;

export const StyledDemoButton = styled(Button)`
  &&.ant-btn-primary {
    /* background-image: linear-gradient(to right, red, purple); */
    /* border-color: rgb(25, 34, 56); */
    border: 1px solid orangered;
    /* background: #192A53;
     */
    background-color: #de283b;
    font-family: "Manrope";

    /* color: white; */
    color: white;

    /* border: none; */
    border-radius: 5px;
    /* margin-left: 10px; */
    margin-top: 20px;
    /* padding: 0 20px; */
    width: 130px;
    height: 50px;
    font-size: 16px;
    text-align: center;
    display: inline;

    @media (max-width: 768px) {
      width: 100%;
      height: 45px;
      font-size: 14px;
      margin-top: 10px;
    }

    &:hover {
      /* background-image: linear-gradient(to right, purple, red); */
      /* background-color: white;
      border-color: #192238;
      color: #192A53; */
      background-color: white;
      border-color: #de283b;
      color: #de283b;
    }
  }
`;

export const StyledImage = styled.img`
  position: relative;
  z-index: 1; // Ensure the image stays on top
  border-radius: 5px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.4);
  /* width: 100%; // responsive image
  height: auto; // maintain aspect ratio */
  min-height: 250px;
  width: 100%;

  @media (max-width: 1366px) {
    width: 100%;
  }
`;

export const StyledDownArrow = styled(Text)`
  font-size: 20px;
  width: 100%;
  height: 25px;
  display: flex;
  text-align: center;
  justify-content: center;
`;

export const StyledImageDiv = styled.div`
  position: absolute;
  top: -10px; // Adjust to show the top border
  right: -10px; // Adjust to show the right border
  bottom: 10px; // Hidden behind the image
  left: 10px; // Hidden behind the image
  border: 2px solid lightgrey; // Only top border
  // borderRight: "2px solid lightgrey", // Only right border
  border-radius: 10px 10px 10px 10px; // Rounded corners for the top-right
  z-index: 0; // Behind the image
`;

export const StyledImageDiv2 = styled.div`
  position: absolute;
  top: -10px; // Adjust to show the top border
  right: 10px; // Adjust to show the right border
  bottom: 10px; // Hidden behind the image
  left: -12px; // Hidden behind the image
  border: 2px solid lightgrey; // Only top border
  // borderRight: "2px solid lightgrey", // Only right border
  border-radius: 10px 10px 10px 10px; // Rounded corners for the top-right
  z-index: 0; // Behind the image
`;

export const FooterLink = styled.a`
  color: white;
  text-decoration: none;
  font-size: 12px;

  &:hover {
    color: #1677ff;
    text-decoration: underline white;
  }
`;

export const StyledTermsLayout = styled(Layout)`
  width: 100%;
  @media (max-width: 2560px) {
    width: 100% !important;
    height: 100vh !important;
  }
  @media (max-width: 1920px) {
    width: 100% !important;
    height: 100vh !important;
  }
  @media (max-width: 1366px) {
    width: 100% !important;
    height: 70vh !important;
  }
  @media (max-width: 600px) {
    width: 100% !important;
    height: 180px !important;
  }
  @media (max-width: 1180px) {
    width: 350px !important;
    height: 180px !important;
  }

  @media (max-width: 412px) {
    width: 100% !important;
    height: 180px !important;
  }
`;

export const StyledHeroTitle = styled(Title)<{ $textAlign?: string }>`
  margin: 0;
  &&.ant-typography {
    font-weight: 700;
    font-family: "Lato";
    margin-bottom: 16px;
    line-height: 1.2;
    text-align: ${(props) => props.$textAlign || "center"};
    width: 100%;
    font-size: 4.5rem;
    width: 100%;
    @media (max-width: 1920px) {
      font-size: 3.5rem;
    }
    @media (max-width: 1366px) {
      font-size: 2.5rem;
    }
    @media (max-width: 768px) {
      font-size: 2rem;
      white-space: normal;
    }
    @media (max-width: 576px) {
      font-size: 1.75rem;
      white-space: normal;
    }
    @media (max-width: 480px) {
      font-size: 1.5rem;
      white-space: normal;
    }
  }
`;

export const StyledGradientText = styled.span`
  background: linear-gradient(180deg, #ffffff 0%, #6dfdff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0px 2px 5.1px rgba(0, 0, 0, 0.5);
  line-height: 105%;
`;

export const StyledRedGradientText = styled.span`
  background: linear-gradient(180deg, #b80000 66.02%, #ef1e05 92.97%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0px 2px 5.1px rgba(0, 0, 0, 0.5);
`;

export const StyledHeroSubtitle = styled(Title)`
  &&.ant-typography {
    font-weight: 400;
    font-family: "Manrope";
    text-align: center;
    color: #ffffff;
    text-shadow: 0px 2px 5.1px rgba(0, 0, 0, 0.5);
    font-size: 1rem;
    @media (max-width: 1920px) {
      font-size: 1rem;
    }
    @media (max-width: 1366px) {
      font-size: 0.95rem;
    }
    @media (max-width: 768px) {
      font-size: 0.9rem;
    }
    @media (max-width: 576px) {
      font-size: 0.85rem;
    }
    @media (max-width: 480px) {
      font-size: 0.8rem;
    }
  }
`;
